module.exports = __webpack_public_path__ + "img/doubt.dac550de.png";